import { render, staticRenderFns } from "./localChooser.vue?vue&type=template&id=0fcba2c2&"
import script from "./localChooser.vue?vue&type=script&lang=ts&"
export * from "./localChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports